var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddGroup3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 10.5,
    r: 4.5,
    stroke: "#575757",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6616 23.7093C23.5845 21.5005 22.633 19.4128 21.0167 17.9055C19.4003 16.3982 17.2513 15.5947 15.0425 15.6718C12.8337 15.749 10.746 16.7004 9.23872 18.3168C7.73141 19.9332 6.92794 22.0821 7.00508 24.2909",
    stroke: "#575757",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39053 10.077C6.42946 10.3504 4.61984 11.3393 3.27338 12.8735C1.92693 14.4077 1.12795 16.3911 1.01409 18.4819",
    stroke: "#575757",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3518 3.79167C16.0096 3.12632 15.545 2.54675 14.9878 2.08994C14.4305 1.63314 13.7928 1.30913 13.1154 1.1386C12.4379 0.968064 11.7356 0.954748 11.0532 1.0995C10.3708 1.24425 9.72338 1.54389 9.15216 1.9793C8.58095 2.41471 8.09851 2.97633 7.73566 3.62831C7.3728 4.28029 7.13749 5.00832 7.04473 5.76593C6.95198 6.52355 7.00382 7.29412 7.19695 8.02846C7.39008 8.76281 7.72026 9.4448 8.16642 10.0309",
    stroke: "#575757",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8335 9.33325L27.8335 17.6666",
    stroke: "#575757",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 13.5L23.6667 13.5",
    stroke: "#575757",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddGroup3);
export default __webpack_public_path__ + "static/media/add_group3.a1c9b1b3c59ef782af66e7a16f1c2b38.svg";
export { ForwardRef as ReactComponent };